'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dAbstract$002dSet from "./java.util.-Abstract-Set.js";
import * as $j_java$002eutil$002e$002dHash$002dMap$0024$002dKey$002dIterator from "./java.util.-Hash-Map$-Key-Iterator.js";
var $p;
/** @constructor */
function $c_ju_HashMap$KeySet(outer) {
  this.sb = null;
  this.sb = outer;
}
export { $c_ju_HashMap$KeySet as $c_ju_HashMap$KeySet };
$p = $c_ju_HashMap$KeySet.prototype = new $j_java$002eutil$002e$002dAbstract$002dSet.$h_ju_AbstractSet();
$p.constructor = $c_ju_HashMap$KeySet;
/** @constructor */
function $h_ju_HashMap$KeySet() {
}
export { $h_ju_HashMap$KeySet as $h_ju_HashMap$KeySet };
$h_ju_HashMap$KeySet.prototype = $p;
$p.cV = (function() {
  return new $j_java$002eutil$002e$002dHash$002dMap$0024$002dKey$002dIterator.$c_ju_HashMap$KeyIterator(this.sb);
});
$p.T = (function() {
  return this.sb.ga;
});
$p.ae = (function(o) {
  return this.sb.aj(o);
});
$p.la = (function(o) {
  return (this.sb.Pu(o) !== null);
});
var $d_ju_HashMap$KeySet = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_HashMap$KeySet, "java.util.HashMap$KeySet", ({
  n6: 1,
  cg: 1,
  bt: 1,
  aU: 1,
  bc: 1,
  cl: 1
}));
export { $d_ju_HashMap$KeySet as $d_ju_HashMap$KeySet };
